export default {
    messages: {
        user_invited: 'Invitation email sent to the user',
    },
    buttons: {
        invite: 'Invite',
        invite_company_user: 'Invite company user',
        change_role: 'Change role',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        user_not_found: 'User not found',
        company_not_found: 'Company not found',
        user_already_part_of_the_company: 'User is already part of the company',
    },
}
